import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppUpdateDialogComponent } from './app-update-dialog/app-update-dialog.component';
import { NavegacaoComponent } from './navegacao/navegacao.component';
import { BarraLateralComponent } from './barra-lateral/barra-lateral.component';
import { CabecalhoConteudoComponent } from './cabecalho-conteudo/cabecalho-conteudo.component';
import { ReplaceParamsPipe } from './cabecalho-conteudo/replace-params.pipe';
import { RodapeComponent } from './rodape/rodape.component';
import { ArmacaoComponent } from './armacao/armacao.component';
import { LoadingModule } from '../libs/loading/loading.module';
import { ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { PesquisaModule } from '../pesquisa/pesquisa.module';
import { PacienteModule } from '../paciente/paciente.module';
import { AcompanhamentoMeusModule } from '../acompanhamento-meus/acompanhamento-meus.module';
import { SmovaultModule } from '../smovault/smovault.module';



@NgModule({
  declarations: [NavegacaoComponent,
    BarraLateralComponent,
    CabecalhoConteudoComponent,
    ReplaceParamsPipe,
    RodapeComponent,
    ArmacaoComponent,
    AppUpdateDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    ProgressButtonModule,
    ReactiveFormsModule,
    DialogModule,
    PesquisaModule,
    SmovaultModule,
    PacienteModule,
    AcompanhamentoMeusModule,
    RouterModule.forChild([])
  ],
  exports: [
    ArmacaoComponent,
    AppUpdateDialogComponent
  ]
})
export class CoreModule { }
